/* eslint-disable */
import React, { useState } from 'react';

const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';
const setToken = (t) => localStorage.setItem('dashboard_token', t);

// ─── Shared styles ───────────────────────────────────────────────────────────
const inputStyle = {
  width: '100%', boxSizing: 'border-box',
  padding: '11px 14px', fontSize: 14,
  border: '1.5px solid #cfd8dc', borderRadius: 8,
  outline: 'none', color: '#263238', background: 'white',
};
const labelStyle = {
  display: 'block', fontSize: 12, fontWeight: 600,
  color: '#37474f', marginBottom: 5, letterSpacing: '0.4px',
};
const btnPrimary = (loading) => ({
  padding: '12px', width: '100%', marginTop: 4,
  background: loading ? '#90a4ae' : 'linear-gradient(135deg, #1a237e, #0d47a1)',
  border: 'none', borderRadius: 8,
  color: 'white', fontSize: 15, fontWeight: 600,
  cursor: loading ? 'not-allowed' : 'pointer',
  boxShadow: loading ? 'none' : '0 4px 16px rgba(13,71,161,0.3)',
  transition: 'all 0.2s',
});

// ─── Wrapper (shared blue background) ───────────────────────────────────────
function PageWrapper({ children }) {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1a237e 0%, #0d47a1 50%, #01579b 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    }}>
      <div style={{
        position: 'absolute', inset: 0, opacity: 0.05,
        backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
        backgroundSize: '40px 40px',
      }} />
      <div style={{
        position: 'relative', background: 'white', borderRadius: 16,
        padding: '40px 36px', width: '100%', maxWidth: 440,
        boxShadow: '0 24px 64px rgba(0,0,0,0.3)',
        maxHeight: '95vh', overflowY: 'auto',
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{
            width: 56, height: 56, borderRadius: 14,
            background: 'linear-gradient(135deg, #1a237e, #0d47a1)',
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 26, marginBottom: 12,
            boxShadow: '0 8px 24px rgba(13,71,161,0.3)',
          }}>🏫</div>
          <h1 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: '#1a237e' }}>
            Vision 2030 Schools
          </h1>
          <p style={{ margin: '5px 0 0', fontSize: 13, color: '#607d8b' }}>
            Ministry of Preschool and School Education — Uzbekistan
          </p>
        </div>
        {children}
      </div>
    </div>
  );
}

// ─── LOGIN ───────────────────────────────────────────────────────────────────
function LoginForm({ onLogin, onRequestAccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Login failed'); return; }
      setToken(data.token);
      onLogin({ isAdmin: data.isAdmin, username: data.username, userRole: data.userRole, scopeType: data.scopeType, scopeValue: data.scopeValue });
    } catch {
      setError('Cannot reach server. Please try again.');
    } finally { setLoading(false); }
  };

  return (
    <>
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        <div>
          <label style={labelStyle}>USERNAME</label>
          <input type="text" value={username} onChange={e => setUsername(e.target.value)}
            required autoFocus placeholder="Enter username" style={inputStyle}
            onFocus={e => e.target.style.borderColor = '#0d47a1'}
            onBlur={e => e.target.style.borderColor = '#cfd8dc'} />
        </div>
        <div>
          <label style={labelStyle}>PASSWORD</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)}
            required placeholder="Enter password" style={inputStyle}
            onFocus={e => e.target.style.borderColor = '#0d47a1'}
            onBlur={e => e.target.style.borderColor = '#cfd8dc'} />
        </div>
        {error && (
          <div style={{
            background: '#fff3f3', border: '1px solid #ffcdd2',
            borderRadius: 8, padding: '10px 14px', fontSize: 13, color: '#c62828',
          }}>⚠️ {error}</div>
        )}
        <button type="submit" disabled={loading} style={btnPrimary(loading)}>
          {loading ? 'Signing in…' : 'Sign In'}
        </button>
      </form>
      <div style={{ textAlign: 'center', marginTop: 20 }}>
        <span style={{ fontSize: 13, color: '#90a4ae' }}>Don't have access? </span>
        <button onClick={onRequestAccess} style={{
          background: 'none', border: 'none', color: '#0d47a1',
          fontSize: 13, fontWeight: 600, cursor: 'pointer', padding: 0,
        }}>Request Access</button>
      </div>
      <p style={{ marginTop: 20, marginBottom: 0, textAlign: 'center', fontSize: 11, color: '#b0bec5' }}>
        Secure access · Session expires after 8 hours
      </p>
    </>
  );
}

// ─── REGISTER ────────────────────────────────────────────────────────────────
function RegisterForm({ onBack }) {
  const [form, setForm] = useState({
    firstName: '', lastName: '', role: '', institution: '',
    email: '', username: '', password: '', confirmPassword: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const set = (field) => (e) => setForm(f => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password !== form.confirmPassword) {
      setError('Passwords do not match'); return;
    }
    if (form.password.length < 8) {
      setError('Password must be at least 8 characters'); return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username: form.username,
          password: form.password,
          firstName: form.firstName,
          lastName: form.lastName,
          role: form.role,
          institution: form.institution,
          email: form.email,
        }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Registration failed'); return; }
      setSuccess(true);
    } catch {
      setError('Cannot reach server. Please try again.');
    } finally { setLoading(false); }
  };

  if (success) {
    return (
      <div style={{ textAlign: 'center', padding: '12px 0' }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
        <h2 style={{ color: '#1a237e', marginBottom: 8 }}>Request Submitted</h2>
        <p style={{ color: '#546e7a', fontSize: 14, lineHeight: 1.6 }}>
          Your access request has been submitted.<br />
          The administrator will review and approve your account.
        </p>
        <button onClick={onBack} style={{ ...btnPrimary(false), marginTop: 24 }}>
          Back to Login
        </button>
      </div>
    );
  }

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 20, gap: 10 }}>
        <button onClick={onBack} style={{
          background: 'none', border: 'none', cursor: 'pointer',
          color: '#607d8b', fontSize: 20, padding: 0, lineHeight: 1,
        }}>←</button>
        <h2 style={{ margin: 0, fontSize: 17, fontWeight: 700, color: '#1a237e' }}>
          Request Access
        </h2>
      </div>
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          <div>
            <label style={labelStyle}>FIRST NAME *</label>
            <input type="text" value={form.firstName} onChange={set('firstName')}
              required placeholder="First name" style={inputStyle}
              onFocus={e => e.target.style.borderColor = '#0d47a1'}
              onBlur={e => e.target.style.borderColor = '#cfd8dc'} />
          </div>
          <div>
            <label style={labelStyle}>LAST NAME *</label>
            <input type="text" value={form.lastName} onChange={set('lastName')}
              required placeholder="Last name" style={inputStyle}
              onFocus={e => e.target.style.borderColor = '#0d47a1'}
              onBlur={e => e.target.style.borderColor = '#cfd8dc'} />
          </div>
        </div>
        <div>
          <label style={labelStyle}>ROLE / JOB TITLE</label>
          <input type="text" value={form.role} onChange={set('role')}
            placeholder="e.g. IT Manager, School Director" style={inputStyle}
            onFocus={e => e.target.style.borderColor = '#0d47a1'}
            onBlur={e => e.target.style.borderColor = '#cfd8dc'} />
        </div>
        <div>
          <label style={labelStyle}>INSTITUTION</label>
          <input type="text" value={form.institution} onChange={set('institution')}
            placeholder="e.g. Ministry of Education, School name" style={inputStyle}
            onFocus={e => e.target.style.borderColor = '#0d47a1'}
            onBlur={e => e.target.style.borderColor = '#cfd8dc'} />
        </div>
        <div>
          <label style={labelStyle}>EMAIL ADDRESS *</label>
          <input type="email" value={form.email} onChange={set('email')}
            required placeholder="your@email.com" style={inputStyle}
            onFocus={e => e.target.style.borderColor = '#0d47a1'}
            onBlur={e => e.target.style.borderColor = '#cfd8dc'} />
        </div>
        <div style={{ borderTop: '1px solid #eceff1', paddingTop: 12, marginTop: 2 }}>
          <label style={labelStyle}>USERNAME *</label>
          <input type="text" value={form.username} onChange={set('username')}
            required placeholder="Choose a username" style={inputStyle}
            onFocus={e => e.target.style.borderColor = '#0d47a1'}
            onBlur={e => e.target.style.borderColor = '#cfd8dc'} />
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          <div>
            <label style={labelStyle}>PASSWORD *</label>
            <input type="password" value={form.password} onChange={set('password')}
              required placeholder="Min. 8 characters" style={inputStyle}
              onFocus={e => e.target.style.borderColor = '#0d47a1'}
              onBlur={e => e.target.style.borderColor = '#cfd8dc'} />
          </div>
          <div>
            <label style={labelStyle}>CONFIRM PASSWORD *</label>
            <input type="password" value={form.confirmPassword} onChange={set('confirmPassword')}
              required placeholder="Repeat password" style={inputStyle}
              onFocus={e => e.target.style.borderColor = '#0d47a1'}
              onBlur={e => e.target.style.borderColor = '#cfd8dc'} />
          </div>
        </div>
        {error && (
          <div style={{
            background: '#fff3f3', border: '1px solid #ffcdd2',
            borderRadius: 8, padding: '10px 14px', fontSize: 13, color: '#c62828',
          }}>⚠️ {error}</div>
        )}
        <button type="submit" disabled={loading} style={btnPrimary(loading)}>
          {loading ? 'Submitting…' : 'Submit Request'}
        </button>
      </form>
    </>
  );
}

// ─── MAIN EXPORT ─────────────────────────────────────────────────────────────
export default function LoginPage({ onLogin }) {
  const [view, setView] = useState('login'); // 'login' | 'register'

  return (
    <PageWrapper>
      {view === 'login'
        ? <LoginForm onLogin={onLogin} onRequestAccess={() => setView('register')} />
        : <RegisterForm onBack={() => setView('login')} />
      }
    </PageWrapper>
  );
}
